import { render, staticRenderFns } from "./formMyApprovedTask.vue?vue&type=template&id=64c2d979&"
import script from "./formMyApprovedTask.vue?vue&type=script&lang=js&"
export * from "./formMyApprovedTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports